import * as React from "react";
const Stop = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.05809941,7 L16.0580994,7 C16.6103842,7 17.0580994,7.44771525 17.0580994,8 L17.0580994,16 C17.0580994,16.5522847 16.6103842,17 16.0580994,17 L8.05809941,17 C7.50581466,17 7.05809941,16.5522847 7.05809941,16 L7.05809941,8 C7.05809941,7.44771525 7.50581466,7 8.05809941,7 Z M8.05809941,8 L8.05809941,16 L16.0580994,16 L16.0580994,8 L8.05809941,8 Z" }));
Stop.displayName = "Stop";
var Stop_default = Stop;
export {
  Stop_default as default
};
